import React, { Component } from 'react';
import { SPURETEXT } from '../../utils';
import ReviewStars from '../review-stars';
import MaTags from './ma-tags';
import './index.scss';

function CommonTitle(props) {
  const { showSegmentTitle, subject } = props;
  if (showSegmentTitle) return null;
  return (
    <h1 className="module-pdp-title" title={SPURETEXT(subject)}>
      {SPURETEXT(subject)}
    </h1>
  );
}

function SegmentTitle(props) {
  const { showSegmentTitle, spuName, subject } = props;
  if (!showSegmentTitle) return null;
  return [
    <h1 className="module-pdp-title" title={SPURETEXT(spuName)} key="pdptitle">
      {SPURETEXT(spuName)}
    </h1>,
    <h2 className="module-sub-title" title={SPURETEXT(subject)} key="subtitle">
      {SPURETEXT(subject)}
    </h2>,
  ];
}

export default class Title extends Component {
  render() {
    const { product, i18n, tradeInfo, seller = {} } = this.props;
    const { hasSPU, subject, spu = {} } = product;
    const { sellerSelfOperated } = seller;
    const { spuName } = spu;
    const showSegmentTitle = !!hasSPU;
    return (
      <div className="detail-title-section detail-mainscreen-center-grid J-ma-title-wrap">
        {/* alibaba自营店铺标识 */}
        {sellerSelfOperated ? (
          <div
            style={{
              marginBottom: 8,
            }}
          >
            <img
              src={i18n['title.alibabaselection']}
              style={{
                height: 21,
              }}
              alt="alibaba-icon"
            />
          </div>
        ) : null}
        <span
          className="promotion-title-tag pt-before"
          id="detail-title-tags-before-title"
          key="promotion-title-tag pt-before"
        />
        <CommonTitle
          showSegmentTitle={showSegmentTitle}
          subject={subject}
          key="title"
        />
        <MaTags hasSPU={hasSPU} i18n={i18n} tradeInfo={tradeInfo} />
        <SegmentTitle
          showSegmentTitle={showSegmentTitle}
          subject={subject}
          spuName={spuName}
          key="seg-title"
        />
        <span
          className="promotion-title-tag pt-after"
          id="detail-title-tags-after-title"
          key="promotion-title-tag pt-after"
        />
        <ReviewStars i18n={i18n} key="reviewStars" />
      </div>
    );
  }
}
